import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { map, switchMap, toArray } from 'rxjs/operators';
import { AntDataResponse, AntSortLoadingParams } from '@antony/ng-ui';
import { ResourceApiService } from '@api/models';
import { PaymentConditionDto, PaymentConditionsApiService } from '@api/api.service';
import { LoadingParamsUtils } from '@api/utils';

@Injectable({
  providedIn: 'root',
})
export class PaymentConditionService implements ResourceApiService<PaymentConditionDto> {
  constructor(private api: PaymentConditionsApiService) {}

  getData(params: Partial<AntSortLoadingParams<PaymentConditionDto>>): Observable<AntDataResponse<PaymentConditionDto>> {
    return this.api
      .getPagedPaymentConditions(
        LoadingParamsUtils.getSkipFrom(params),
        LoadingParamsUtils.getTakeFrom(params),
        LoadingParamsUtils.getFilterNamesFrom(params),
        LoadingParamsUtils.getFilterValueFrom(params),
        LoadingParamsUtils.getSortNamesFrom(params),
        LoadingParamsUtils.getApiSortDirection(params)
      )
      .pipe(
        map((res) => ({
          data: res.data || [],
          maxCount: res.maxCount || 0,
        }))
      );
  }

  get(id: number): Observable<PaymentConditionDto> {
    return this.api.getPaymentCondition(id).pipe(map((x) => x.data as PaymentConditionDto));
  }

  create(item: PaymentConditionDto): Observable<PaymentConditionDto> {
    return this.api.createPaymentCondition(item).pipe(map((x) => x.data as PaymentConditionDto));
  }

  update(id: number, item: PaymentConditionDto): Observable<PaymentConditionDto> {
    return this.api.updatePaymentCondition(id, item).pipe(map((x) => x.data as PaymentConditionDto));
  }

  delete(id: number): Observable<boolean> {
    return this.api.deletePaymentCondition(id).pipe(map((x) => x.success));
  }

  deleteBulk(ids: number[]): Observable<boolean[]> {
    return this.api.deleteBulkPaymentConditions(ids).pipe(
      map((res) => res.data || []),
      switchMap((res) => from(res)),
      map((res) => res.success),
      toArray()
    );
  }
}
